export const locales = {
	minLabel: 'Valeur min',
	maxLabel: 'Valeur max'
};
